import { SVGProps } from 'react';

const Maximize2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 9V3h-6m6 0-7 7M3 21l7-7m-7 1v6h6"
    />
  </svg>
);
export default Maximize2;
